import React from 'react';

export default function HRCopilotPrivacySkills() {
  return (
    <div className="hrcopilot-dual-features">
      <style>{`
        .hrcopilot-dual-features {
          background-color: #fafafa;
        }

        .hrcopilot-privacy-section {
          max-width: 1400px;
          margin: 0 auto;
          padding: 100px 40px;
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 80px;
          align-items: center;
        }

        .hrcopilot-privacy-content {
          padding-right: 20px;
        }

        .hrcopilot-privacy-title {
          font-size: 4rem;
          font-weight: 700;
          font-style: italic;
          margin-bottom: 40px;
          color: #1a1a1a;
          line-height: 1.15;
          font-family: 'Brush Script MT', cursive, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
        }

        .hrcopilot-privacy-line1 {
          display: block;
        }

        .hrcopilot-privacy-line2 {
          display: block;
          position: relative;
        }

        .hrcopilot-privacy-underline {
          position: absolute;
          bottom: 8px;
          left: 0;
          width: 260px;
          height: 12px;
          background-color: #ff6b6b;
          z-index: -1;
          border-radius: 4px;
        }

        .hrcopilot-privacy-desc {
          font-size: 1.15rem;
          color: #4a4a4a;
          line-height: 1.8;
        }

        .hrcopilot-privacy-bold {
          font-weight: 700;
          color: #1a1a1a;
        }

        .hrcopilot-privacy-visual {
          position: relative;
        }

        .hrcopilot-privacy-card {
          background-color: white;
          border-radius: 12px;
          padding: 40px;
          box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
          position: relative;
        }

        .hrcopilot-privacy-badge {
          position: absolute;
          top: -20px;
          right: 40px;
          width: 80px;
          height: 80px;
          background: linear-gradient(135deg, #ff6b6b 0%, #ff8e8e 100%);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        }

        .hrcopilot-privacy-icon {
          width: 50px;
          height: 50px;
          position: relative;
        }

        .hrcopilot-privacy-icon::before {
          content: '👁';
          font-size: 30px;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }

        .hrcopilot-privacy-icon::after {
          content: '';
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%) rotate(45deg);
          width: 3px;
          height: 50px;
          background-color: #1a1a1a;
        }

        .hrcopilot-profile-header {
          display: flex;
          align-items: center;
          gap: 20px;
          margin-bottom: 24px;
          padding-bottom: 20px;
          border-bottom: 1px solid #e0e0e0;
        }

        .hrcopilot-profile-photo {
          width: 80px;
          height: 80px;
          border-radius: 8px;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        }

        .hrcopilot-profile-info {
          flex: 1;
        }

        .hrcopilot-profile-name {
          font-size: 1.5rem;
          font-weight: 700;
          color: #1a1a1a;
          margin: 0 0 4px 0;
        }

        .hrcopilot-profile-role {
          font-size: 1rem;
          color: #666;
          margin: 0 0 8px 0;
        }

        .hrcopilot-profile-tags {
          display: flex;
          gap: 8px;
        }

        .hrcopilot-tag {
          padding: 4px 12px;
          border-radius: 4px;
          font-size: 0.85rem;
          font-weight: 600;
        }

        .hrcopilot-tag-employee {
          background-color: #ffe5e5;
          color: #d32f2f;
        }

        .hrcopilot-tag-consultant {
          background-color: #e3f2fd;
          color: #1976d2;
        }

        .hrcopilot-privacy-tabs {
          display: flex;
          gap: 8px;
          margin-bottom: 24px;
          border-bottom: 2px solid #e0e0e0;
        }

        .hrcopilot-privacy-tab {
          padding: 12px 20px;
          font-size: 0.95rem;
          font-weight: 600;
          color: #666;
          background: none;
          border: none;
          cursor: pointer;
          border-bottom: 3px solid transparent;
          transition: all 0.3s ease;
        }

        .hrcopilot-privacy-tab.active {
          color: #1a1a1a;
          border-bottom-color: #1a1a1a;
        }

        .hrcopilot-privacy-label {
          font-size: 1rem;
          font-weight: 700;
          color: #1a1a1a;
          margin-bottom: 16px;
          display: block;
        }

        .hrcopilot-privacy-field {
          display: grid;
          grid-template-columns: 180px 1fr;
          gap: 20px;
          padding: 12px 0;
          border-bottom: 1px solid #f0f0f0;
        }

        .hrcopilot-privacy-field-name {
          font-size: 0.95rem;
          font-weight: 600;
          color: #666;
        }

        .hrcopilot-privacy-field-value {
          font-size: 0.95rem;
          color: #1a1a1a;
        }

        .hrcopilot-skills-section {
          max-width: 1400px;
          margin: 0 auto;
          padding: 100px 40px;
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 80px;
          align-items: center;
        }

        .hrcopilot-skills-visual {
          order: 1;
        }

        .hrcopilot-skills-preview {
          background-color: white;
          border-radius: 12px;
          padding: 30px;
          box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
        }

        .hrcopilot-skills-preview-img {
          width: 100%;
          height: auto;
          border-radius: 8px;
        }

        .hrcopilot-skills-content {
          order: 2;
        }

        .hrcopilot-skills-title {
          font-size: 4rem;
          font-weight: 700;
          font-style: italic;
          margin-bottom: 40px;
          color: #1a1a1a;
          line-height: 1.15;
          font-family: 'Brush Script MT', cursive, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
        }

        .hrcopilot-skills-line1 {
          display: block;
        }

        .hrcopilot-skills-line2 {
          display: block;
          position: relative;
        }

        .hrcopilot-skills-highlight {
          position: relative;
          display: inline-block;
        }

        .hrcopilot-skills-highlight::after {
          content: '';
          position: absolute;
          bottom: 8px;
          left: 0;
          width: 100%;
          height: 18px;
          background-color: #fdb755;
          z-index: -1;
          border-radius: 4px;
        }

        .hrcopilot-skills-desc {
          font-size: 1.15rem;
          color: #4a4a4a;
          line-height: 1.8;
        }

        @media (max-width: 1024px) {
          .hrcopilot-privacy-section,
          .hrcopilot-skills-section {
            grid-template-columns: 1fr;
            gap: 60px;
          }

          .hrcopilot-privacy-title,
          .hrcopilot-skills-title {
            font-size: 3rem;
          }

          .hrcopilot-skills-visual {
            order: 2;
          }

          .hrcopilot-skills-content {
            order: 1;
          }
        }

        @media (max-width: 768px) {
          .hrcopilot-privacy-section,
          .hrcopilot-skills-section {
            padding: 60px 20px;
          }

          .hrcopilot-privacy-title,
          .hrcopilot-skills-title {
            font-size: 2.5rem;
          }

          .hrcopilot-privacy-card,
          .hrcopilot-skills-preview {
            padding: 24px;
          }

          .hrcopilot-privacy-field {
            grid-template-columns: 1fr;
            gap: 8px;
          }

          .hrcopilot-privacy-tabs {
            overflow-x: auto;
            flex-wrap: nowrap;
          }
        }
      `}</style>

      {/* Privacy Section */}
      <div className="hrcopilot-privacy-section">
        <div className="hrcopilot-privacy-content">
          <h2 className="hrcopilot-privacy-title">
            <span className="hrcopilot-privacy-line1">Keep the private</span>
            <span className="hrcopilot-privacy-line2">
              stuff private
              <span className="hrcopilot-privacy-underline"></span>
            </span>
          </h2>

          <p className="hrcopilot-privacy-desc">
            <span className="hrcopilot-privacy-bold">Restricted access settings</span> to protect employee's private information - emergency contacts, visa information, and more.
          </p>
        </div>

        <div className="hrcopilot-privacy-visual">
          <div className="hrcopilot-privacy-card">
            <div className="hrcopilot-privacy-badge">
              <div className="hrcopilot-privacy-icon"></div>
            </div>

            <div className="hrcopilot-profile-header">
              <div className="hrcopilot-profile-photo"></div>
              <div className="hrcopilot-profile-info">
                <h3 className="hrcopilot-profile-name">Audrey Peterson</h3>
                <p className="hrcopilot-profile-role">Consultant</p>
                <div className="hrcopilot-profile-tags">
                  <span className="hrcopilot-tag hrcopilot-tag-employee">Employee ×</span>
                  <span className="hrcopilot-tag hrcopilot-tag-consultant">Consultant ×</span>
                </div>
              </div>
            </div>

            <div className="hrcopilot-privacy-tabs">
              <button className="hrcopilot-privacy-tab">Resume</button>
              <button className="hrcopilot-privacy-tab">Work Information</button>
              <button className="hrcopilot-privacy-tab active">Private Information</button>
              <button className="hrcopilot-privacy-tab">HR Settings</button>
            </div>

            <span className="hrcopilot-privacy-label">PRIVATE CONTACT</span>

            <div className="hrcopilot-privacy-field">
              <span className="hrcopilot-privacy-field-name">Private Address</span>
              <span className="hrcopilot-privacy-field-value">Rue du Laid Burniat<br/>Louvain-La-Neuve, Belgium 1348</span>
            </div>

            <div className="hrcopilot-privacy-field">
              <span className="hrcopilot-privacy-field-name">Email</span>
              <span className="hrcopilot-privacy-field-value">Audrey.peterson2020@example.com</span>
            </div>

            <div className="hrcopilot-privacy-field">
              <span className="hrcopilot-privacy-field-name">Phone</span>
              <span className="hrcopilot-privacy-field-value">555-555-1234</span>
            </div>

            <div className="hrcopilot-privacy-field">
              <span className="hrcopilot-privacy-field-name">Bank Account Number</span>
              <span className="hrcopilot-privacy-field-value">111-111-111 - ING</span>
            </div>
          </div>
        </div>
      </div>

      {/* Skills Section */}
      <div className="hrcopilot-skills-section">
        <div className="hrcopilot-skills-visual">
          <div className="hrcopilot-skills-preview">
            <img 
              src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=600&h=500&fit=crop&q=80" 
              alt="HR Copilot skills tracking interface"
              className="hrcopilot-skills-preview-img"
            />
          </div>
        </div>

        <div className="hrcopilot-skills-content">
          <h2 className="hrcopilot-skills-title">
            <span className="hrcopilot-skills-line1">Show off</span>
            <span className="hrcopilot-skills-line2">
              <span className="hrcopilot-skills-highlight">those skills</span>
            </span>
          </h2>

          <p className="hrcopilot-skills-desc">
            Record every employee's unique skills, so the next time you are looking for a French-speaking JavaScript expert, you know exactly who to call.
          </p>
        </div>
      </div>
    </div>
  );
}